const apiAccess = 'd8864515a36141ef97325a3a974ad7c9'

const geoIPLocationWebsite = 'https://api.ipgeolocation.io/ipgeo'

import axios from 'axios'

export default{

    async getGeoIPLocation(){
    
        const urlRequest = geoIPLocationWebsite + `?apiKey=${apiAccess}`;

        // console.log(`urlRequest: ${urlRequest}`);

        const result = await axios({method: 'get',url: urlRequest})

        return result;
    },

    async getCountryCode(){

        const urlRequest = geoIPLocationWebsite + `?apiKey=${apiAccess}`;

        // console.log(`urlRequest: ${urlRequest}`);

        const result = await axios({method: 'get',url: urlRequest})

        return result.data.country_code2;
    }
}
